import type { DatePresetLabelConfig } from "../models";
import type { AnalyzeDatePreset } from "../types";

export const ANALYZE_DATE_PRESETS = Object.freeze({
    LAST_7_DAYS: "LAST_7_DAYS",
    LAST_14_DAYS: "LAST_14_DAYS",
    LAST_30_DAYS: "LAST_30_DAYS",
    LAST_90_DAYS: "LAST_90_DAYS",
    LAST_YEAR: "LAST_YEAR",
} as const);

// insertion order is the menu order (options render via Object.values)
export const ANALYZE_COMPARISON_MODES = Object.freeze({
    PREVIOUS_RANGE: "PREVIOUS_RANGE",
    PREVIOUS_YEAR: "PREVIOUS_YEAR",
    BASELINE: "BASELINE",
    NO_COMPARISON: "NO_COMPARISON",
} as const);

export const ANALYZE_DATE_PRESET_LABEL_CONFIGS: Record<
    AnalyzeDatePreset,
    DatePresetLabelConfig
> = Object.freeze({
    [ANALYZE_DATE_PRESETS.LAST_7_DAYS]: {
        labelKey: "time:lastXDays",
        count: 7,
    },
    [ANALYZE_DATE_PRESETS.LAST_14_DAYS]: {
        labelKey: "time:lastXDays",
        count: 14,
    },
    [ANALYZE_DATE_PRESETS.LAST_30_DAYS]: {
        labelKey: "time:lastXDays",
        count: 30,
    },
    [ANALYZE_DATE_PRESETS.LAST_90_DAYS]: {
        labelKey: "time:lastXDays",
        count: 90,
    },
    [ANALYZE_DATE_PRESETS.LAST_YEAR]: { labelKey: "time:lastYear" },
});
